import BottledJuiceProduct from 'models/BottledJuiceProduct'
import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import { bottleJuiceInitialState } from './constants'
import JuicePackage from './JuicePackage'

const bottledJuiceOptions = {
  packagingInfo: (
    <JuicePackage
      model={BottledJuiceProduct}
      packagingInitialState={bottleJuiceInitialState}
    />
  ),
  productTitle: 'Juice',
  model: BottledJuiceProduct,
  validCategories: ['54'],
  validSubCategories: ['001', '002', '101'],
}

const BottledJuice = () => <ProductForm product={bottledJuiceOptions} />

export default BottledJuice
